export const CaseInfoStatusEnum = {
	CREATED: "CREATED",
	AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED", // link expired or all attempts exhausted for that email
	AUTHENTICATED: "AUTHENTICATED", // already verified
	DECLINED: "DECLINED", // rejected by user
	NOT_FOUND: "NOT_FOUND"
};
